import { render, staticRenderFns } from "./_base-resource-image.vue?vue&type=template&id=0ed1cf58&scoped=true"
import script from "./_base-resource-image.vue?vue&type=script&setup=true&lang=js"
export * from "./_base-resource-image.vue?vue&type=script&setup=true&lang=js"
import style0 from "./_base-resource-image.vue?vue&type=style&index=0&id=0ed1cf58&prod&lang=scss&scoped=true"
import style1 from "./_base-resource-image.vue?vue&type=style&index=1&id=0ed1cf58&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ed1cf58",
  null
  
)

export default component.exports